(() => {
  function init(scope = document) {
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    scope.querySelectorAll('[data-real-life-card]').forEach(card => {
      if (card.dataset.motionReady) return;
      card.dataset.motionReady = 'true';
      const image = card.querySelector('img, video');
      const isVideo = image?.tagName === 'VIDEO';
      const button = card.querySelector('[data-motion-toggle]');
      if (!image || !button) return;
      const mediaLabel = image.alt || image.getAttribute('aria-label') || '';
      button.hidden = false;
      let visible = false;
      let userPaused = false;
      let playing = false;
      const setPlaying = enabled => {
        playing = enabled;
        if (isVideo) {
          if (enabled) {
            if (!image.getAttribute('src')) image.src = image.dataset.motionSrc;
            image.play().catch(() => setPlaying(false));
          } else image.pause();
        } else {
          const target = enabled ? image.dataset.motionSrc : image.dataset.posterSrc;
          if (image.getAttribute('src') !== target) image.src = target;
        }
        button.textContent = enabled ? button.dataset.pauseLabel : button.dataset.playLabel;
        button.setAttribute('aria-label', button.textContent + ' — ' + mediaLabel);
        button.setAttribute('aria-pressed', String(enabled));
      };
      button.addEventListener('click', () => {
        userPaused = playing;
        setPlaying(!playing);
      });
      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver(entries => {
          visible = entries[0].isIntersecting;
          setPlaying(visible && !userPaused && !reduceMotion.matches && !document.hidden);
        }, { threshold: 0.3 });
        observer.observe(card);
      }
      document.addEventListener('visibilitychange', () => {
        setPlaying(visible && !userPaused && !reduceMotion.matches && !document.hidden);
      });
      reduceMotion.addEventListener('change', () => {
        setPlaying(visible && !userPaused && !reduceMotion.matches && !document.hidden);
      });
      image.addEventListener('error', () => {
        userPaused = true;
        setPlaying(false);
      });
    });
  }
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
